import { Block, Container, RichText, Heading, Button } from '~/components'
import type { CtaBlock } from './types'

import * as styles from './CtaBlock.css'

type Props = {
  block: CtaBlock
}

export function CtaBlock({ block }: Props) {
  return (
    <Block options={block.options}>
      <Container>
        {!block.title && !block.richtext ? (
          <>
            {block.cta && (
              <div className={styles.actionCentered}>
                <Button href={block.cta.link.url} target={block.cta.link.target}>
                  {block.cta.label || block.cta.link.text}
                </Button>
              </div>
            )}
          </>
        ) : (
          <div className={styles.content}>
            <div className={styles.main}>
              {block.title && (
                <div>
                  <Heading margin="medium" as="h2" level={block.options.heading}>
                    {block.title}
                  </Heading>
                </div>
              )}

              {block.richtext && (
                <div className={styles.text}>
                  <RichText content={block.richtext} />
                </div>
              )}

              {block.cta && (
                <div className={styles.action}>
                  <Button href={block.cta.link.url} target={block.cta.link.target}>
                    {block.cta.label || block.cta.link.text}
                  </Button>
                </div>
              )}
            </div>
          </div>
        )}
      </Container>
    </Block>
  )
}
